module.exports = __webpack_public_path__ + "static/media/for_rent.d743a516.svg";